<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='讲解签到'">
    <div class="list">
      <div class="item border-box" v-for="(item,index) in root" :key="index">
        <div class="item-t bold">{{item.name}}  <font v-if="item.protype==2"> ({{item.num}}人团)</font>
          <span class="fr state1" v-if="item.order_state==10">待支付</span>
          <span class="fr state2" v-if="(item.order_state==11||item.order_state==13)&&(item.type==1||item.type==8)">已关闭</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==2">待接单</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==3">拼团中</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==4">待使用</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==5">进行中</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==6">待评价</span>
          <span class="fr state2" v-if="item.order_state==12&&item.type==7">已完成</span>
          <span class="fr state2" v-if="item.order_state==15">已退款</span>
        </div>
        <div class="item-m border-box box" @click="toOrderDesc(item.ordernum)">
          <img class="img l" :src="item.logo" alt="">
          <div class="flex">
            <div class="text" v-if="item.protype==1"><span>出行人数：</span>{{item.people}}</div>
            <div class="text" v-if="item.protype==2"><span>购买数量：</span>{{item.buynum}}</div>

            <div class="text"><span>总价：</span>￥{{item.totalmoeny}}</div>
            <div class="text" v-if="item.time"><span>预约时间：</span>{{item.time.slice(5)}} {{item.stime}}-{{item.etime}}</div>
          </div>
        </div>
        <div class="item-b border-box" v-if="item.order_state==12&&item.type==4">
          <div class="item-b-r fr btn linear" @click="signOrder(index)" v-if="item.isSign&&!item.sign">签到</div>
          <div class="item-b-r fr btn cor-p" v-else>已签到</div>
        </div>
      </div>
    </div>
    <div class="load-tip">
      <p>
        <span class="l"></span>
        <span class="m">{{loadText}}</span>
        <span class="r"></span>
      </p>
    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {userSignList, userSign} from "@/service/getData";
  import {wxGetPosition,wxShareme, payMoney} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        loadText: "数据加载中",
        orderState: '', //支付订单状态 10 待支付 11 取消支付 12 支付成功 13 超时取消 14 退款申请 15 退款成功
        type: '', //产品订单状态 1 未支付 2已支付(等待接单) 3拼团中 4待使用 5进行中 6待评价 7已完成 8游客取消 9景区取消
        root:[],//订单列表
        P400: 0, //系统维护中
      }
    },
    computed: {},

    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.userSignListFun();

    },
    methods: {
      async userSignListFun(){
        let res = await userSignList({
          openid: this.userInfo.openid,
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          var root = res.data;
          for(var i=0; i<root.length; i++){
            var item = root[i];
            if(this.bjDate(item.time+' '+item.stime)){
              root[i].isSign = true;
            }else {
              root[i].isSign = false;
            }
          }
          this.root = res.data;
          if(this.root.length==1&&!this.root[0].sign){
            this.userSignFun(0,1)
          }else if(this.root.length==1&&this.root[0].sign){
            this.toOrderDesc(this.root[0].ordernum)
          }

          if (res.data.length > 0) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '暂无数据'
          }
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //判断当前时间是否在签到时间内
      bjDate(date1) {
        var date = new Date();
        if (date1) {
          if (typeof date1 === 'string') {
            date1 = new Date(date1.replace(/-/g, "/"));
          } else if (typeof date1 === 'number') {
            date1 = new Date(date1);
          }
        }
        var time = date1.getTime() - date.getTime();
        return (time>0 && time<=(7200*1000))?true:false;
      },


      //签到
      signOrder: function (ind){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要签到此订单吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.userSignFun(ind)
          }
        }).catch(function(res){
          if(res == 'success') {
            self.userSignFun(ind)
          }
        })
      },
      //确定签到
      async userSignFun(ind,type){
        let res = await userSign({
          ordernum: this.root[ind].ordernum
        });
        if(res.errcode == "00000"){
          if(type==1){
            this.toOrderDesc(this.root[ind].ordernum)
          }else {
            this.userSignListFun();
          }

          this.$toast("签到成功")
        }else{
          this.$toast(res.errmsg)
        }
      },


      //跳转至订单详情页面
      toOrderDesc:function(ordernum){
        this.$router.push({
          path: `/order-desc?${'ordernum='+ ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },
    },
    watch: {},
    components: {
        P400
    }
  }

</script>

<style scoped>
  .page{min-height:100vh;padding: .24rem .3rem .4rem;background: #ededed;}
  .item{margin-top:.24rem;padding:0 .3rem;background: #fff;border-radius: .2rem;}
  .item:first-child{margin-top: 0;}
  .item .item-t{height:1rem;font:.32rem/1rem "Microsoft YaHei";color: #333;border-bottom:1px solid #e3e3e3;}
  .item .state1{font-size: .28rem;color: #fa4f45;}
  .item .state2{font-size: .28rem;color: #999;}
  .item-m{padding: .2rem 0;border-bottom:1px solid #e3e3e3;}
  .item-m .img{width: 1.48rem;height: 1.48rem;margin-right:.2rem;border-radius: .06rem;object-fit:cover;overflow: hidden;}
  .item-m .flex{padding-top:.06rem;font: .28rem/.46rem "Microsoft YaHei";color: #333;}
  .item-m .flex span{color: #666;}
  .item-b{height: 1.32rem;}
  .item-b .btn{width: 2rem;height: .72rem;margin-left:.12rem;margin-top:.28rem;text-align: center;font: .32rem/.72rem "Microsoft YaHei";}
  .item-b .btn:last-child{margin-left: 0;}
  .item-b-img .img{width: .52rem;height: .52rem;margin-top:.38rem;margin-left:-.06rem;border-radius: 50%;border:.02px solid #fff;object-fit:cover;overflow: hidden;}
  .item-b-img .icon-dian{height: .06rem;margin-top: .63rem;margin-left: .1rem;}
  .item-b-info{font-size: .22rem;color: #333;margin-right: .24rem;margin-top: .36rem;}
  .item-b-info .t1{padding-top: .13rem;}
  .linear1{}
</style>



// WEBPACK FOOTER //
// src/page/home/order-sign.vue